module.exports = __webpack_public_path__ + "media/images/svg/add-7ccb63615075d9ea84dbe28a04bd9d21.svg";